import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 数据概览（controller/admin /v1/admin/stats/**）
 */

export function getOverviewStats() {
  return axios.get(`${base.url}/service/v1/admin/stats/overview`)
}

export function getTrendStats(days) {
  return axios.get(`${base.url}/service/v1/admin/stats/trend`, { params: { days: days || 7 } })
}

export function getAgentPerformance(params) {
  return axios.get(`${base.url}/service/v1/admin/stats/agent-performance`, { params })
}